/**
 * Guests who need taking somewhere, by a time, in the golf cart.
 *
 * A beat posts one (`chapters.js`, `posts`). Posting it is the whole of what is
 * authored: the guests whose rows say `shuttle` come out and wait where the
 * row says, and the clock starts. Everything after that already existed. They
 * get in the back the way anybody offered a lift does (`riders.js`); the road
 * has its bends, its branches and its snake whether anybody is in a hurry or
 * not; and where they are let out is where they are.
 *
 *   waits     where they stand to be picked up, in feet, one point a guest
 *   to        where they are going: a room, and the table they walk to once
 *             they are let out in it, one point a guest
 *   due       the time on the clock they have to be there by
 *   gives up  game minutes after `due` at which, not there, they stop waiting
 *             for you and are driven over by somebody else, and it is over
 *   works     zones the job puts you in (`access.js`), like a strike
 *   award     standing when everybody is there on time
 *   late      standing when they got there, after the time
 *   missed    standing when they never did
 *
 * A late or missed guest complains, through the path a guest's complaint about
 * you always goes through. What happened on the way is theirs to complain
 * about too, and they do that without this file: a branch in the face is an
 * impact on the bus like any other.
 */
export const SHUTTLES = [
  {
    id: 'caytons-shuttle',
    title: 'Two for dinner at the Caytons',
    waits: [[-47, -78], [-33, -78]],
    to: { room: 'caytons', seats: [[-430, 81], [-426, 81]] },
    due: '19:30',
    givesUp: 60,
    works: ['caytons-zone'],
    award: { valet: 12 },
    late: { valet: -4 },
    missed: { valet: -8 },
  },
];

export const SHUTTLES_BY_ID = Object.freeze(Object.fromEntries(SHUTTLES.map((row) => [row.id, row])));

export default SHUTTLES;
